import { render, staticRenderFns } from "./AccountTransfer.vue?vue&type=template&id=1c8dd3f4&scoped=true"
import script from "./AccountTransfer.vue?vue&type=script&lang=js"
export * from "./AccountTransfer.vue?vue&type=script&lang=js"
import style0 from "./AccountTransfer.vue?vue&type=style&index=0&id=1c8dd3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8dd3f4",
  null
  
)

export default component.exports